module.exports = __webpack_public_path__ + "media/images/sp/brands/eight/_main-visual-text-81e254e624e468d3217d8fa37b9457e6.svg";